import React from "react";
import { Route, Redirect } from "react-router-dom";
import PrivateLayout from "../layouts/PrivateLayout.js";
import _authService from "../modules/authService";
import PropTypes from 'prop-types';
import "../App.css?v=2"

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        //Also check role
        _authService.isAuthenticated(props)
            ?
            <PrivateLayout>
                <Component {...props} />
            </PrivateLayout>
            :
            <Redirect to={{
                pathname: '/',
                state: { from: props.location }
            }} />
    )} />
)

PrivateRoute.propTypes = {
    component:PropTypes.node
};

export default PrivateRoute